/* Bekofy on Kalles: quick add on bekofy-card, collection filter drawer, sort, 1/2 columns */
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  async function quickAdd(button) {
    if (button.getAttribute('aria-busy') === 'true') return;
    button.setAttribute('aria-busy', 'true');
    button.classList.remove('is-error');
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: String(button.dataset.bkAdd).split(',').filter(Boolean).map((id) => ({ id: Number(id), quantity: 1 })) }),
      });
      const data = await res.json();
      if (!res.ok || data.status) {
        button.classList.add('is-error');
        button.title = data.description || data.message || '';
        return;
      }
      button.classList.add('is-added');
      setTimeout(() => button.classList.remove('is-added'), 1800);
      // Kalles: refresh the cart drawer + count, then open it
      document.dispatchEvent(new CustomEvent('cart:reload'));
      const drawer = document.querySelector('hdt-cart-drawer');
      setTimeout(() => {
        if (drawer && typeof drawer.open === 'function') drawer.open();
        else window.location.href = `${root}cart`;
      }, 350);
    } catch (e) {
      button.classList.add('is-error');
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  function setCols(cols) {
    document.querySelectorAll('[data-bk-grid]').forEach((grid) => grid.setAttribute('data-cols', cols));
    document.querySelectorAll('[data-bk-cols]').forEach((b) => b.setAttribute('aria-pressed', String(b.getAttribute('data-bk-cols') === cols)));
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const add = target.closest('[data-bk-add]');
    if (add) {
      event.preventDefault();
      event.stopPropagation();
      quickAdd(add);
      return;
    }

    const opener = target.closest('[data-bk-open]');
    if (opener) {
      const dialog = document.getElementById(opener.getAttribute('data-bk-open'));
      if (dialog instanceof HTMLDialogElement) {
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
      return;
    }

    if (target.closest('[data-bk-close]') || (target instanceof HTMLDialogElement && target.classList.contains('bk-drawer'))) {
      target.closest('dialog')?.close();
      return;
    }

    const colButton = target.closest('[data-bk-cols]');
    if (colButton) {
      const cols = colButton.getAttribute('data-bk-cols');
      setCols(cols);
      try { localStorage.setItem('bk-cols', cols); } catch (e) {}
    }
  }, true);

  document.addEventListener('close', (event) => {
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('bk-drawer')) {
      document.documentElement.style.overflow = '';
    }
  }, true);

  document.addEventListener('change', (event) => {
    const select = event.target;
    if (select instanceof HTMLSelectElement && select.form && select.form.hasAttribute('data-bk-sort')) select.form.requestSubmit();
  });

  // Keep the collection filter bar just under Kalles' sticky header
  let raf = 0;
  const syncStickyTop = () => {
    raf = 0;
    const header = document.querySelector('hdt-sticky-header, .hdt-section-header, #shopify-section-header');
    if (!header) return;
    const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty('--bk-sticky-top', `${bottom}px`);
  };
  const queueSync = () => { if (!raf) raf = requestAnimationFrame(syncStickyTop); };
  window.addEventListener('scroll', queueSync, { passive: true });
  window.addEventListener('resize', queueSync);

  const init = () => {
    if (document.querySelector('.bk-coll__bar')) syncStickyTop();
    try {
      const saved = localStorage.getItem('bk-cols');
      if (saved) setCols(saved);
    } catch (e) {}
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
